// TurnoComparisonBarChart.jsx
import React from 'react';
import { GroupedBarChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const TurnoComparisonBarChart = ({
  data = [],
  title = 'Comparación Día vs Noche (tiempo productivo)',
  height = '400px',
}) => {
  // Carbon Charts espera formato { group, key, value }
  const chartData = data.flatMap(d => ([
    {
      group: 'Día',
      key: d.fecha,
      value: d.dia_h,
    },
    {
      group: 'Noche',
      key: d.fecha,
      value: d.noche_h,
    },
  ]));

  const options = {
    title,
    height,
    theme: 'g100', // ⬅⬅⬅ modo dark → texto blanco

    axes: {
      left: {
        mapsTo: 'value',
        title: 'Horas productivas',
        scaleType: 'linear',
      },
      bottom: {
        mapsTo: 'key',
        title: 'Fecha',
        scaleType: 'labels',
      },
    },

    legend: {
      enabled: true,
    },

    color: {
      scale: {
        Día: '#0F62FE',    // azul Carbon
        Noche: '#8A3FFC', // morado Carbon
      },
    },
  };

  return <GroupedBarChart data={chartData} options={options} />;
};

export default TurnoComparisonBarChart;